import { useCallback, useRef } from 'react';

type ManualSectionPriority = {
  sectionId: string;
  until: number;
};

export const useManualSectionPriority = (priorityMs: number) => {
  const manualSectionPriorityRef = useRef<ManualSectionPriority | null>(null);

  const markManualSection = useCallback(
    (sectionId: string) => {
      manualSectionPriorityRef.current = {
        sectionId,
        until: Date.now() + priorityMs,
      };
    },
    [priorityMs]
  );

  const shouldApplySpySection = useCallback((sectionId: string) => {
    const manualPriority = manualSectionPriorityRef.current;
    if (!manualPriority) return true;

    if (Date.now() < manualPriority.until && sectionId !== manualPriority.sectionId) {
      return false;
    }

    if (Date.now() >= manualPriority.until) {
      manualSectionPriorityRef.current = null;
    }

    return true;
  }, []);

  return {
    markManualSection,
    shouldApplySpySection,
  };
};
